import { appConstants } from "../../../application/configurations/constants";

export class AppUtilityService {
  /**
  * Favicon icon change as per light and dark theme
  */
  static favIcoLoad = () => {
   let FaviconLinkSelector = document.querySelector("link[rel~='icon']");
  
   let searchParams = new URLSearchParams(window.location.href).get('c')?.toLowerCase();
    let context = localStorage.getItem('context');
      
     if(FaviconLinkSelector) {
      if(searchParams === appConstants.intranet && searchParams  !== null || context===appConstants.intranet) {
         FaviconLinkSelector.setAttribute('href', `${window.location.origin}/intranet_favicon.ico`);
       } else if(window.matchMedia('(prefers-color-scheme: dark)').matches) {
         FaviconLinkSelector.setAttribute('href', `${window.location.origin}/Discover_dark.ico`);
       } else {
         FaviconLinkSelector.setAttribute('href', `${window.location.origin}/Discover.ico`);
       }
     }
 }
}

